/* Local dependencies */
import { GroupName, User, UserStatus } from '../../types';

export enum ListUsersActionTypes {
  LIST_USERS_REQUEST = 'LIST_USERS_REQUEST',
  LIST_USERS_SUCCESS = 'LIST_USERS_SUCCESS',
  LIST_USERS_ERROR = 'LIST_USERS_ERROR',
  RESET_ERROR = 'RESET_LIST_USERS_ERROR',
  RESET_STATE = 'RESET_LIST_USERS_STATE',
}

export interface ListUsersFilter {
  groupNames?: GroupName[];
  statuses?: UserStatus[];
}

export interface ListUsersInput {
  query?: string;
  from?: number;
  filter?: ListUsersFilter;
  currentPage?: number;
  size?: number;
}

export interface ListUsers {
  type: ListUsersActionTypes.LIST_USERS_REQUEST;
  input: ListUsersInput;
}

export interface ListUsersSuccess {
  type: ListUsersActionTypes.LIST_USERS_SUCCESS;
  users: User[];
  total: number;
}

export interface ListUsersError {
  type: ListUsersActionTypes.LIST_USERS_ERROR;
  error: Error;
}

export interface ResetListUsersError {
  type: ListUsersActionTypes.RESET_ERROR;
}

export interface ResetListUsersState {
  type: ListUsersActionTypes.RESET_STATE;
}

export type ListUsersAction = ListUsers | ListUsersSuccess | ListUsersError | ResetListUsersError | ResetListUsersState;
